import { ArrowIcon02 } from './../icon/ArrowIcon';
import './buttonButton.css';

export const BottomButton = ({ label = '', variant = '', disabled = false, onClick }) => {
  return (
    <div className='bottom-button'>
      <div className='gradient'></div>
      <div className='button-wrap'>
        <button className={variant} disabled={disabled || variant === 'loading'} onClick={onClick}>
          {variant !== 'loading' ? <span>{label}</span> : <div className='loader-st01'></div>}
        </button>
      </div>
    </div>
  );
};

export const BottomButtonDefault = ({ label = '', variant = '', disabled = false, onClick }) => {
  return (
    <div className='bottom-button default-btn'>
      <div className='button-wrap'>
        <button className={variant} disabled={disabled || variant === 'loading'} onClick={onClick}>
          {variant !== 'loading' ? <span>{label}</span> : <div className='loader-st01'></div>}
        </button>
      </div>
    </div>
  );
};

export const PopupBottomButton = ({ label = '선택', onClick }) => {
  return (
    <div className='pop-bottom-button'>
      <div className='gradient'></div>
      <div className='pop-button-wrap'>
        <button className={'secondary'} disabled={false} onClick={onClick}>
          <span>{label}</span>
        </button>
      </div>
    </div>
  );
};

export const ConfirmConsentButton = ({ label = '', onClick, terms, onTermsClick, onTermsCheckClick, disabled }) => {
  return (
    <div className='pop-bottom-button'>
      <div className='gradient'></div>
      <div className='agree-chk-form'>
        <div className='agree-chk-list'>
          {terms.map((term) => {
            return (
              <div
                className='agree-item choice_type3'
                key={term.termsId}
                onClick={() => {
                  onTermsCheckClick(term);
                }}
              >
                <input
                  type='checkbox'
                  name=''
                  aria-label=''
                  className='inp_choice'
                  checked={term.isChecked}
                  style={{ pointerEvents: 'none' }}
                  onChange={() => { }}
                />
                <label className='' aria-hidden='false'>
                  <span className='icon icon_check'></span>
                  {term.termsTitle}
                </label>
                <button
                  className='detail-btn'
                  type='button'
                  onClick={(e) => {
                    e.stopPropagation();
                    onTermsClick(term);
                  }}
                >
                  <ArrowIcon02 />
                </button>
              </div>
            );
          })}
        </div>
      </div>
      <div className='pop-button-wrap'>
        <button className={'primary'} disabled={disabled} onClick={onClick}>
          <span>{label}</span>
        </button>
      </div>
    </div>
  );
};

